module.exports = __webpack_public_path__ + "img/rating-page-slider-mobile-1.334ab726.png";